import Classnames from 'classnames'
import { useRecoilState, useRecoilValue, useRecoilCallback } from 'recoil'
import {
  isBuilder,
  screen,
  screenOpen,
  editSectionId,
  editSectionWrapperId,
} from '@/store/builder/store'

function Image({ id, contentID, sectionData, wrapperId }) {
  const isBuilderApp = useRecoilValue(isBuilder)
  const [getSreen, setScreen] = useRecoilState(screen)
  const [getScreenOpen, setScreenOpen] = useRecoilState(screenOpen)
  const [getEditSectionId, setEditSectionId] = useRecoilState(editSectionId)
  const [getEditSectionWrapperId, setEditSectionWrapperId] =
    useRecoilState(editSectionWrapperId)

  const clickImage = () => {
    if (isBuilderApp) {
      // open to edit
      setScreen('editsection')
      setScreenOpen(true)
      setEditSectionId(id)
      setEditSectionWrapperId(wrapperId)
    } else {
      // open to link if has link
      if (sectionData.data.link) {
        window.open(sectionData.data.link, '_blank')
        // analytics.track('Image Section Link Click')
      }
    }
  }

  return (
    <div
      onClick={clickImage}
      className={Classnames(
        'sectionImage bg-no-repeat  w-full h-full overflow-hidden bg-center bg-contain',
        {
          'md:bg-cover': sectionData.data.style == 'cover',
          'md:bg-cover imgRoundWithPadding':
            sectionData.data.style == 'round-with-padding',
          'md:bg-cover imgFullsize ': sectionData.data.style == 'fullsize',
          'md:bg-contain': sectionData.data.style == 'contain',
          'md:bg-auto': sectionData.data.style == 'auto',
          'md:bg-skew-to-fit imgFullsize':
            sectionData.data.style == 'skew-to-fit',
          'md:bg-center': sectionData.data.position == 'center',
          'md:bg-top': sectionData.data.position == 'top',
          'md:bg-bottom': sectionData.data.position == 'bottom',
          'cursor-pointer': sectionData.data.link,
        }
      )}
      style={{
        backgroundImage: 'url(' + sectionData.data.image_url + ')',
        marginBottom: 'var(--canvas-thickness)',
        width:
          sectionData.data.style == 'round-with-padding'
            ? 'calc(100% - 40px)'
            : 'calc(100% - var(--canvas-thickness))',
      }}
    >
      {sectionData.data.style == 'skew-to-fit' && (
        <img
          className="w-full h-full "
          style={
            {
              // marginBottom: 'var(--canvas-thickness)',
              // paddingRight: 'var(--canvas-thickness)',
            }
          }
          src={sectionData.data.image_url}
        />
      )}
      {sectionData.data.style == 'fullsize' && (
        <img
          className="object-cover w-full h-full "
          style={
            {
              // marginBottom: 'var(--canvas-thickness)',
              // paddingRight: 'var(--canvas-thickness)',
            }
          }
          src={sectionData.data.image_url}
        />
      )}
      {sectionData.data.style == 'round-with-padding' && (
        <img
          className="object-cover w-full h-full "
          style={{
            marginBottom: 'var(--canvas-thickness)',
            // paddingRight: 'var(--canvas-thickness)',
          }}
          src={sectionData.data.image_url}
        />
      )}
    </div>
  )
}

export default Image
